import React from 'react';
import './AboutSection.css';
// import { IMAGES } from '../../assets/image';
import { CREDIT_UNION } from '../../assets/constants';

const AboutSection = () => {
  return (
    <section className="about-section" role="region" aria-labelledby="about-heading">
      <div className="layout-container">
        <h2 id="about-heading" className="about-heading">
          About {CREDIT_UNION.INFO.NAME}
        </h2>
        <p className="about-text" dangerouslySetInnerHTML={{ __html: CREDIT_UNION.ABOUT.TEXT }}>
          {/* {CREDIT_UNION.ABOUT.TEXT} */}
        </p>

        <div className="about-btn-wrapper">
          <a
            href="/ApplicationForm"
            className="about-btn"
            role="button"
            aria-label="Apply now for refinancing"
          >
            APPLY NOW
          </a>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
